import { InternshipType,InternStatus } from '../service-proxies';


export class InternFeeSummaryDto implements IInternFeeSummaryDto {
    internId!: number;
    internName!: string | undefined;
    internshipType!: InternshipType;
    status!: InternStatus;
    monthlyFee!: number;
    amountReceived!: number;

    constructor(data?: IInternFeeSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internId = _data["internId"];
            this.internName = _data["internName"];
            this.internshipType = _data["internshipType"];
            this.status = _data["status"];
            this.monthlyFee = _data["monthlyFee"];
            this.amountReceived = _data["amountReceived"];
        }
    }

    static fromJS(data: any): InternFeeSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternFeeSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internId"] = this.internId;
        data["internName"] = this.internName;
        data["internshipType"] = this.internshipType;
        data["status"] = this.status;
        data["monthlyFee"] = this.monthlyFee;
        data["amountReceived"] = this.amountReceived;
        return data; 
    }
}

export interface IInternFeeSummaryDto {
    internId: number;
    internName: string | undefined;
    internshipType: InternshipType;
    status: InternStatus;
    monthlyFee: number;
    amountReceived: number;
}

